"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EProductType = void 0;
exports.EProductType = {
    scpi: "scpi",
    private_equity: "private_equity",
    natural_assets: "natural_assets",
    diversification: "diversification",
};
